<template>
	<StatusIndicator v-if="visible" variant="pill" class="status pa-1" :status="status" :label="translateStatus()" />
</template>

<script setup lang="ts">
	import { getIconForInitiator, Initiator } from "@/enums/Initiator";
	import { EntityType } from "@/types/EntityType";
	import { computed, onMounted, ref } from "vue";
	import { translateConversationStatus, translateProjectStatus } from "@/helpers/status";
	import constants from "@/api/constants";
	import StatusIndicator from "@/components/common/StatusIndicator.vue";

	const initiator = ref<Initiator>(Initiator.RECORDING);

	const props = defineProps<{
		status: string;
		entityType: EntityType;
		initiator: Initiator;
		appointmentName: string;
		sourceType: string;
	}>();

	// Only show the status for conversations on mobile that are not "Not Started" because it shows a hyphen and doesn't look good

	const visible = computed(() => {
		return (
			(props.entityType === "conversation" && props.status !== constants.CONVERSATION_STATUS.NotStarted) ||
			props.entityType === "project"
		);
	});

	onMounted(() => {
		initiator.value = props.initiator;
	});

	function translateStatus(): string {
		if (props.entityType === "conversation") {
			return translateConversationStatus(props.status);
		} else if (props.entityType === "project") {
			return translateProjectStatus(props.status);
		}

		return props.status;
	}

	function getIconForConversation() {
		// this feels like a hack but right now, the only way to differentiate
		// between a scheduled and live video call is by checking if the appointment is null.
		// TODO: fix this
		if (props.initiator == Initiator.SCHEDULED_VIDEO && props.appointmentName == null) {
			initiator.value = Initiator.LIVE_VIDEO;
		}
		if (props.sourceType == "FORM") {
			initiator.value = Initiator.FORM;
		}
		return getIconForInitiator(initiator.value);
	}
</script>

<style scoped lang="scss">
	.status {
		font-size: 0.625rem;
	}
</style>
